<template>
  <v-container v-if="cardset && cardset.api.getLoaded" fluid>
    <h2 class="text-center">
      {{ cardset.name }}
      <v-btn
              v-if="canEditCardsets"
              secondary
              @click="edit()"
      >
        <v-icon left>mdi-pencil</v-icon>
        {{ $t('nav.edit') }}
      </v-btn>
    </h2>
    <v-simple-table fixed-header class="text-start">
      <thead>
        <tr>
          <th>{{ $t('heading.stack') }}</th>
          <th class="centered">
            <v-tooltip>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">close</v-icon>
              </template>
              <span>{{ $t('tooltip.notMemorized') }}</span>
            </v-tooltip>
          </th>
          <th class="centered">
            <v-tooltip>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">check</v-icon>
              </template>
              <span>{{ $t('tooltip.memorizedShortTerm') }}</span>
            </v-tooltip>
          </th>
          <th class="centered">
            <v-tooltip>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">star</v-icon>
              </template>
              <span>{{ $t('tooltip.memorizedLongTerm') }}</span>
            </v-tooltip>
          </th>
        </tr>
      </thead>
      <tbody>
      <tr
              v-for="stack in cardset.stacks.list"
              :key="stack.id"
              @click="onStackClick(stack.id)"
      >
        <td>{{ stack.name }}</td>
        <td class="centered">
          {{ a2h(stack.status.level0Count) }}
        </td>
        <td class="centered">
          {{ a2h(stack.status.level1Count) }}
        </td>
        <td class="centered">
          {{ a2h(stack.status.level2Count) }}
        </td>
      </tr>
      </tbody>
    </v-simple-table>
    <cardset-edit v-if="canEditCardsets" :pk="cardset.id" v-model="dialog" @closed="dialog = false"></cardset-edit>
  </v-container>
  <v-container v-else>
    <h2 class="text-center">
      {{ $t('nav.loading') }}
    </h2>
  </v-container>
</template>

<script>
  import LoginRedirect from "@/components/mixins/LoginRedirect";
  import CardsetEdit from "./CardsetEdit";
  import basic from "../mixins/basic";
  // import {Cardset} from "@/models/Cardset";
  import StackMixin from "@/components/mixins/StackMixin";
  // import {Cardset} from "@/models/Cardset";
  // import {Cardset} from "../../models/Cardset";

  export default {
    name: "CardsetDetail",
    components: {CardsetEdit},
    mixins: [basic, StackMixin, LoginRedirect],
    props: {
      pk: {
        required: true,
        type: Number,
      }
    },
    data: function () {
      return {
        detailUrl: '/cardset/',
        dialog: false,
      }
    },
    methods: {
      // eslint-disable-next-line no-unused-vars
      onDetailSuccess(response) {
        this.$store.commit('setCurrentCardset', this.cardset);
      },
      edit() {
        this.dialog = true;
      },
      onStackClick(stackId) {
        // this.$router.push({
        //   name: 'stack-detail',
        //   params: {
        //     pk: stackId,
        //     cardsetId: this.cardset.id
        //   }
        // })
        this.$router.push({
          name: 'stack-quiz',
          params: {
            pk: stackId,
            cardsetId: this.cardset.id,
            level: 3,
          }
        });
      }
    },
    created () {
      let that = this;
      this.fetchCardset(this.pk).then(function () {
        that.$store.dispatch('resetBreadCrumbs');
        that.$store.commit('pushBreadCrumb', {
          text: that.cardset.name,
          to: {name: 'cardset-detail', params: { pk: that.pk } },
          enabled: true,
        });
      });
    }
  }
</script>

<style scoped>
  td.centered, th.centered {
    text-align: center;
    alignment: center;
    margin-right: auto;
    margin-left: auto;
  }
</style>
